import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@root/environments/environment';
import { AccessControlUserRepository } from '@shared/access-control-users/data-access/models/access-control-user.model';
import { Observable } from 'rxjs';
import {
  TemporaryIdentityTokenModel,
  TemporaryIdentityTokenResponseModel,
} from '@shared/access-control-users/data-access/models/temporary-identity-token.model';

@Injectable({
  providedIn: 'root',
})
export class AccessControlUserRepositoryService
  implements AccessControlUserRepository
{
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/v2/AccessControl`;
  getUserPhoto(employeeId: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/Users/${employeeId}/Photo`, {
      responseType: 'blob',
    });
  }

  getTemporaryIdentityToken(payload: TemporaryIdentityTokenModel) {
    return this.http.post<TemporaryIdentityTokenResponseModel>(
      `${this.baseUrl}/Token/TemporaryIdentityToken`,
      payload
    );
  }
}
